
import { Component, Input, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { BotService } from 'src/app/shared/services/bot.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';

@Component({
  selector: 'app-function-name-suggest',
  templateUrl: './function-name-suggest.component.html',
  styleUrl: './function-name-suggest.component.scss',
  imports: [InputGroupModule, ButtonModule, InputGroupAddonModule]
})
export class FunctionNameSuggestComponent {
  @Input() public isSuggestingName: boolean = false;
  public readonly descriptionString = input<string>('');
  public readonly mode = input<'standalone' | 'addon'>('addon');
  // eslint-disable-next-line @angular-eslint/no-output-native
  public readonly finish = output<string>();
  constructor(public botService: BotService, private rssService: RouteShareService) { }

  public async suggestName() {
    if (!this.isSuggestingName) {
      this.isSuggestingName = true;
      const answer: string = await this.botService.suggestName(this.rssService.botConfig._id, this.descriptionString());
      this.finish.emit(answer);
      this.isSuggestingName = false;
    }
  }
}
